var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraUmbrella({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 10.3564 19.9814 10.7085 19.945 11.0553H11V20H9.2V11.0553H0.0550179C0.0186467 10.7085 0 10.3564 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 1.8C5.7223 1.8 2.20964 5.07554 1.83336 9.25528H18.1666C17.7904 5.07554 14.2777 1.8 10 1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraUmbrella);
export default __webpack_public_path__ + "static/media/cra-umbrella.83cc1ca79ed71964be7a65361f453f04.svg";
export { ForwardRef as ReactComponent };